import matter from 'gray-matter';
import { blogPostsData } from '../content/blogData';

export interface BlogPost {
  slug: string;
  title: string;
  description: string;
  date: string;
  category: string;
  author?: string;
  tags?: string[];
  content: string;
  readingTime?: string;
  canonicalUrl?: string;
  metaDescription?: string;
  keywords?: string[];
  published?: boolean;
  cta?: {
    title?: string;
    buttonText?: string;
    buttonLink?: string;
  };
}

export interface BlogPostMetadata {
  slug: string;
  title: string;
  description: string;
  date: string;
  category: string;
  author?: string;
  tags?: string[];
  readingTime?: string;
}

// Get all blog posts metadata (without content for performance)
export const getAllBlogPostsMetadata = (): BlogPostMetadata[] => {
  return Object.values(blogPostsData)
    .filter(post => post.published !== false) // Only include published posts
    .map(({ content, ...metadata }) => metadata)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

// Get a single blog post by slug
export const getBlogPostBySlug = (slug: string): BlogPost | null => {
  const post = blogPostsData[slug];
  // Only return the post if it exists and is published
  if (post && post.published !== false) {
    return post;
  }
  return null;
};

// Helper function to format date
export const formatBlogDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
};